<!-- SecurityLayout.vue -->
<template>
  <div class="auth-wrapper">
    <div class="all-wrapper menu-side with-pattern">
      <router-view/>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>